import React, { Component } from 'react'
import { TextField } from '@material-ui/core';
import { createSupplier } from '../../api/resources/Suppliers';
import LoadingButton from '../LoadingButton';

export default class CreateSupplierForm extends Component {

  constructor(props) {
    super(props)
    this.state = {
      supplier: null,
      errors: {},
      isSaving: false
    }
    this.handleUpdate = this.handleUpdate.bind(this)
    this.handleSave = this.handleSave.bind(this)
    this.onError = this.onError.bind(this)
  }

  componentDidMount() {
    const supplier = (this.props.supplier) ? this.props.supplier : {}
    this.setState({supplier})
  }

  onError(err) {
    this.setState({isSaving: false})
    alert("Something went wrong.")
  }

  validationErrors() {
    const { supplier } = this.state;
    let errors = {};
    if (!supplier.name) errors.name = 'Required';
    // if (!supplier.email && !supplier.telephone) {
    //   errors.telephone = 'Contact info required';
    //   errors.email = 'Contact info required';
    // }
    if (Object.keys(errors).length > 0) {
      this.setState({errors})
      return true;
    }
  }

  handleUpdate(payload) {
    const [field, value] = Object.entries(payload)[0]
    this.setState({
      supplier: {
        ...this.state.supplier,
        [field]: value
      },
      errors: {}
    })
  }

  handleSave(event) {
    event.preventDefault()
    if (this.validationErrors()) return false;

    const { supplier } = this.state;
    const { onCreate } = this.props;
    this.setState({isSaving: true})
    
    createSupplier(supplier).then(res => {
      this.setState({isSaving: false})
      if (onCreate) onCreate(res)
    }).catch(this.onError);
  }

  render() {

    const { isEditing } = this.props;
    const { supplier, errors, isSaving } = this.state;

    return (
      supplier ? <>
        <div style={{margin: '16px 0'}}>
          <TextField
            type="text"
            name="name"
            label="Company name"
            InputLabelProps={{ shrink: true }}
            {...(!isEditing && { InputProps: { readOnly: true }} )}
            {...(errors.name && { error: true })}
            placeholder="Company name"
            onChange={event => this.handleUpdate({name: event.target.value})}
            fullWidth
          />
        </div>
        <div style={{margin: '16px 0'}}>
          <TextField
            type="text"
            name="name"
            label="Telephone"
            InputLabelProps={{ shrink: true }}
            {...(!isEditing && { InputProps: { readOnly: true }} )}
            {...(errors.name && { error: true })}
            placeholder="Telephone number"
            onChange={event => this.handleUpdate({telephone: event.target.value})}
            fullWidth
          />
        </div>
        <div style={{margin: '16px 0 32px'}}>
          <TextField
            type="email"
            name="name"
            label="Email address"
            InputLabelProps={{ shrink: true }}
            {...(!isEditing && { InputProps: { readOnly: true }} )}
            {...(errors.name && { error: true })}
            placeholder="Email address"
            onChange={event => this.handleUpdate({email: event.target.value})}
            fullWidth
          />
        </div>
        { isEditing && <div style={{margin: '16px 0 0'}}>
          <LoadingButton
            fullWidth
            color="primary"
            variant="contained"
            loading={isSaving}
            onClick={this.handleSave}
          >Save</LoadingButton>
        </div> }
      </> : null
    )
  }
}
